import React, {
  Fragment,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react"
import PropTypes from "prop-types"
import BudgetingVacio from "assets/images/budgeting/NoCaps.png"
import DownloadBudgetModal from "components/Feed/DownloadBudget"
import ContactContext from "context/contact/contactContext"
import LayoutBudget from "./LayoutBudget"
import NewCapitulo from "./NewCapitulo"
import { useParams } from "react-router-dom"
import Budget2023Context from "context/budget2023/Budget2023Context"
import { HelveticaBold } from "common/typographies"
import i18n from "i18n"
import AuthContext from "context/auth/authContext"
import ProjectContext from "context/projects/projectContext"
import SendModal from "components/Feed/sendBudgetRefatctor/sendModal"
import TopQuickBudgetMenu from "./options/TopQuickBudgetMenu"
import Loading from "common/Loading"
import * as amplitude from "@amplitude/analytics-browser"
import { getCurrency } from "utils/functions"
import { useWrapperModals } from "context/wrapperModals/WrapperModalsContext"
import useBudgetConfig, {
  BUDGET_CONFIG_TYPES,
} from "hooks/budgeting/useBudgetConfig"
import MarginsModal from "./options/MarginsModal"
import { MarginsDiscountsProvider } from "context/margin/MarginsDiscountsContext"
import { COST } from "./options/margin/FormulasTab"
import { useDecimalFormatter } from "hooks/useDecimalFormatter"
import { useBudgetClientPriceTotal } from "hooks/budgeting/useBudgetClientPriceTotal"
import { TOTALS, MARGINS } from "constants/decimals"
import { currencyFormatDE } from "lib/transformers"
import { isChapterVisibleInSearch } from "utils/budgetUtils"
import { Button } from "@mui/material"
import AddIcon from "@mui/icons-material/Add"

const BudgetStructure = ({
  soyFinal,
  version,
  index,
  imTemplate,
  certificaciones,
}) => {
  const {
    addCapituloV2,
    getBudgetTree,
    budgetTree,
    loadingTree,
    closeBudget,
    isBudgetClosed,
    readyToClose,
    tagsFiltered,
    getVersionTree,
    chaptersChecked,
    partsChecked,
    marginModal,
    budgetMode,
    closeInfo,
  } = useContext(Budget2023Context)
  const { newModalPart } = useWrapperModals()

  const [budgetConfig] = useBudgetConfig()
  const preferencias = budgetConfig[BUDGET_CONFIG_TYPES.PREFERENCES]

  const contactContext = useContext(ContactContext)
  const { Contacts, getContacts } = contactContext
  const { getProjectVersions, projectInfo } = useContext(ProjectContext)
  const [modificado, setModificado] = useState(0)
  const [contador, setCont] = useState(0)
  const { user, openFreeTrialExpire, freeTrialExpired } =
    useContext(AuthContext)
  const { projectId } = useParams()
  const [ocultoFinal, setOcultoFinal] = useState(false)

  const { getDecimals } = useDecimalFormatter()
  const { clientPriceTotalAmount } = useBudgetClientPriceTotal()
  const isTenderClosed = budgetMode === "tender" && isBudgetClosed
  const footerReducedPrice = isTenderClosed
    ? (closeInfo?.reducedPrice ?? budgetTree?.priceReduced)
    : budgetTree?.priceReduced
  const footerClientPriceTotal = isTenderClosed
    ? (closeInfo?.clientPrice ?? clientPriceTotalAmount)
    : clientPriceTotalAmount
  const formattedFooterClientPriceTotal = currencyFormatDE(
    footerClientPriceTotal,
    getCurrency(user["custom:currency"]),
    getDecimals(TOTALS),
  )

  useEffect(() => {
    amplitude.track({
      event_type: certificaciones
        ? "Certificaciones Visited"
        : "Budgeting Visited",
      event_properties: {
        projectId: projectId,
        projectName: projectInfo.name,
        accountEmail: user.email,
      },
    })
    if (version) {
      getVersionTree(version, projectId, soyFinal)
      getContacts()
      getProjectVersions(projectId, projectInfo.createdBy)
    } else {
      getBudgetTree(projectId)
      getContacts()
      getProjectVersions(projectId, projectInfo.createdBy)
    }
  }, [])
  const [dif, setDif] = useState(0)

  useEffect(() => {
    if (budgetTree) {
      if (budgetMode === "tender") {
        const reduced = parseFloat(footerReducedPrice) || 0
        const clientPriceTotal = parseFloat(footerClientPriceTotal) || 0
        if (clientPriceTotal !== 0 || reduced !== 0) {
          setDif(
            currencyFormatDE(
              clientPriceTotal - reduced,
              getCurrency(user["custom:currency"]),
              getDecimals(TOTALS),
            ),
          )
        } else {
          setDif(
            currencyFormatDE(
              parseFloat(0),
              getCurrency(user["custom:currency"]),
              getDecimals(TOTALS),
            ),
          )
        }
      } else if (
        budgetTree.clientPrice != 0 ||
        budgetTree.clientPriceWithoutDiscount != 0
      ) {
        if (preferencias.descuento == true) {
          setDif(
            currencyFormatDE(
              budgetTree.clientPrice - budgetTree.priceReduced,
              getCurrency(user["custom:currency"]),
              getDecimals(TOTALS),
            ),
          )
        } else {
          setDif(
            currencyFormatDE(
              budgetTree.clientPriceWithoutDiscount - budgetTree.priceReduced,
              getCurrency(user["custom:currency"]),
              getDecimals(TOTALS),
            ),
          )
        }
      } else {
        setDif(
          currencyFormatDE(
            parseFloat(0),
            getCurrency(user["custom:currency"]),
            getDecimals(TOTALS),
          ),
        )
      }
    }
  }, [
    budgetMode,
    budgetTree,
    budgetTree?.price,
    budgetTree?.clientPrice,
    budgetTree?.clientPriceWithoutDiscount,
    footerReducedPrice,
    clientPriceTotalAmount,
    footerClientPriceTotal,
    preferencias.descuento,
    user,
    getDecimals,
  ])
  const [margins, setMargins] = useState(0)
  useEffect(() => {
    const margin =
      projectInfo.costeGeneral +
      projectInfo.industrialProfit +
      projectInfo.costeIndirecto
    const clientPrice =
      budgetTree.price * (1 + margin / 100) - budgetTree.totalDiscount
    setMargins(margin)
  }, [budgetTree.price])

  const [showAct, setshowAct] = useState(false)
  const [openSendBudgetModal, setOpenSendBudgetModal] = useState(false)
  const handleSendBudgetModal = () => {
    setOpenSendBudgetModal(true)
  }
  const [openDownloadBudgetModal, setOpenDownloadBudgetModal] = useState(false)
  const handleDownloadBudgetModal = async () => {
    setOpenDownloadBudgetModal(true)
  }
  useEffect(() => {
    if (contador != 0) {
      if (readyToClose == true) {
        setOpenDownloadBudgetModal(true)
      }
    }
  }, [readyToClose])

  const addCapitulo = () => {
    addCapituloV2(
      {
        name: "",
        price: 0,
        clientPrice: 0,
        tags: [],
        subcapitulos: [],
        partidas: [],
        parentId: "root",
        projectId: projectInfo.projectId,
        accountId: user.sub,
        position: budgetTree.subcapitulos.length,
        status: "OPEN",
        customCode: null,
        root: "true",
        sended: "false",
        selfManagement: "false",
      },
      budgetTree.subcapitulos.length,
    )
  }

  let numeroClases = 0

  const [close, setClose] = useState(0)
  useEffect(() => {
    if (close == 1) {
      closeBudget()
      setClose(0)
    }
  }, [close])

  const [modificarMargen, setModificarMargen] = useState(false)
  const [isChecked, setIsChecked] = useState({
    isChecked: false,
    partida: null,
  })

  const [isChecked2, setIsChecked2] = useState({
    isChecked2: false,
    capitulo: null,
  })

  const [filterChapters, setFilterChapters] = useState([])
  const [budgetSearchQuery, setBudgetSearchQuery] = useState("")
  const cargarCapitulosFiltered = () => {
    let aux = []
    for (let i = 0; i < budgetTree.subcapitulos.length; i++) {
      for (let j = 0; j < tagsFiltered.length; j++) {
        for (
          let y = 0;
          y < budgetTree.subcapitulos[i].capituloInfo.tags.length;
          y++
        ) {
          if (
            budgetTree.subcapitulos[i].capituloInfo.tags[y] === tagsFiltered[j]
          ) {
            let trobat2 = false
            for (let z = 0; z < aux.length; z++) {
              if (
                aux[z].capituloInfo.chapterId ==
                budgetTree.subcapitulos[i].capituloInfo.chapterId
              ) {
                trobat2 = true
              }
            }
            if (trobat2 == false) {
              aux.push(budgetTree.subcapitulos[i])
            }
          }
        }
      }
    }
    setFilterChapters(aux)
  }
  useEffect(() => {
    if (
      !loadingTree &&
      budgetTree.subcapitulos.length > 0 &&
      tagsFiltered.length > 0
    ) {
      cargarCapitulosFiltered()
    } else {
      if (tagsFiltered.length == 0) {
        setFilterChapters([])
      }
    }
  }, [tagsFiltered.length, loadingTree])

  const calcMarginWithClientFormula = (cost, price) => {
    const margin = 1 - cost / price
    return margin * 100
  }

  const calcMarginWithCostFormula = (cost, price) => {
    const margin = price / cost - 1
    return margin * 100
  }

  const calcPercentMargin = () => {
    if (!budgetTree) return "0"
    const { descuento } = preferencias
    const { clientPrice, clientPriceWithoutDiscount } = budgetTree
    const priceReduced = footerReducedPrice

    if (!priceReduced) return "0"

    const base =
      budgetMode === "tender"
        ? footerClientPriceTotal
        : descuento
          ? clientPrice
          : clientPriceWithoutDiscount
    if (!base) return "0"

    const margen =
      marginModal.formula === COST
        ? calcMarginWithCostFormula(priceReduced, base)
        : calcMarginWithClientFormula(priceReduced, base)

    return Number.isFinite(margen) ? margen.toFixed(getDecimals(MARGINS)) : "0"
  }

  const [totalPercent, setTotalPercent] = useState(0)
  useEffect(() => {
    setTotalPercent(calcPercentMargin())
  }, [
    budgetMode,
    footerReducedPrice,
    budgetTree.clientPriceWithoutDiscount,
    budgetTree.clientPrice,
    footerClientPriceTotal,
    marginModal.formula,
    marginModal.generalExpenses,
    marginModal.indirectExpenses,
    marginModal.industrialProfit,
    preferencias.descuento,
  ])

  const chaptersSource =
    filterChapters.length > 0 ? filterChapters : budgetTree.subcapitulos
  const budgetSearchTrimmed = budgetSearchQuery.trim()
  const chaptersForList =
    !loadingTree && budgetSearchTrimmed
      ? chaptersSource.filter(c =>
          isChapterVisibleInSearch(c, budgetSearchTrimmed),
        )
      : chaptersSource

  return (
    <MarginsDiscountsProvider>
      <LayoutBudget
        handleSendBudgetModal={handleSendBudgetModal}
        handleDownloadBudgetModal={handleDownloadBudgetModal}
        projectInfo={projectInfo}
        addCapitulo={addCapitulo}
        showAct={showAct}
        setshowAct={setshowAct}
        open3={openSendBudgetModal}
        setOpen3={setOpenSendBudgetModal}
        contactos={Contacts}
        soyFinal={soyFinal}
        setModificado={setModificado}
        version={version}
        index={index}
        certificaciones={certificaciones}
        budgetSearchQuery={budgetSearchQuery}
        setBudgetSearchQuery={setBudgetSearchQuery}
      >
        {loadingTree ? (
          <Loading />
        ) : filterChapters.length == 0 ? (
          budgetTree.subcapitulos.length > 0 ? (
            <div
              style={{ marginBottom: "50px" }}
              data-testid="budget-structure"
            >
              {chaptersForList.length === 0 && budgetSearchTrimmed ? (
                <HelveticaBold
                  style={{
                    color: "#414141",
                    marginTop: "16px",
                    marginBottom: "16px",
                    fontSize: "15px",
                  }}
                >
                  {i18n.t("No hay resultados para la búsqueda")}
                </HelveticaBold>
              ) : (
                chaptersForList.map((subcapitulo, index) => (
                  <NewCapitulo
                    imTemplate={imTemplate}
                    key={subcapitulo.chapterId ?? index}
                    indice={index}
                    capitulo={subcapitulo}
                    desplazamiento={24}
                    numeroClases={numeroClases}
                    numeroIndex={index + 1}
                    lengthSubCap={budgetTree.subcapitulos.length}
                    soyFinal={soyFinal}
                    projectInfo={projectInfo}
                    setModificado={setModificado}
                    modificado={modificado}
                    setClose={setClose}
                    modificarMargen={modificarMargen}
                    setModificarMargen={setModificarMargen}
                    ocultoFinal={ocultoFinal}
                    setOcultoFinal={setOcultoFinal}
                    isChecked={isChecked}
                    setIsChecked={setIsChecked}
                    isChecked2={isChecked2}
                    setIsChecked2={setIsChecked2}
                    priceWidth={3}
                    version={version}
                    certificaciones={certificaciones}
                    budgetSearchQuery={budgetSearchQuery}
                    openModalCreatePartida={newModalPart.open}
                    setOpenModalCreatePartida={(isOpen, chapterId) =>
                      newModalPart.setProperty({
                        open: isOpen,
                        chapterId: chapterId,
                        partida: null,
                      })
                    }
                  />
                ))
              )}
              {projectInfo.status === "CLOSED" ||
              version ||
              isBudgetClosed ||
              certificaciones ? null : (
                <div
                  className="NombreAlign"
                  onClick={freeTrialExpired ? openFreeTrialExpire : addCapitulo}
                >
                  {!isBudgetClosed && (
                    <Button
                      size="small"
                      color="secondary"
                      startIcon={<AddIcon fontSize="small" />}
                      sx={{ marginBottom: "10px" }}
                      data-amplify-analytics-on="click"
                      data-amplify-analytics-name="ChapterCreated"
                      data-amplify-analytics-attrs=""
                      data-element="newChapterBtn"
                      data-testid="budget-add-chapter-button"
                    >
                      {i18n.t("Nuevo capítulo")}
                    </Button>
                  )}
                </div>
              )}
              {
                //Esta es la barrade presupuesto de coste
              }
              {certificaciones ? (
                <div id="desglosePresShow">
                  <div id="PresCoste">
                    <div style={{ marginRight: "15px" }}>
                      <p className="totalE">
                        {currencyFormatDE(
                          budgetTree.totalCertificateProject || 0,
                          getCurrency(user["custom:currency"]),
                          getDecimals(TOTALS),
                        )}
                      </p>
                      <p className="subTitE">Total Certificado</p>
                    </div>
                  </div>
                  <div id="PresCoste">
                    <div style={{ marginRight: "15px" }}>
                      <p className="totalE">
                        {currencyFormatDE(
                          budgetTree.totalPreviousCertificateProject || 0,
                          getCurrency(user["custom:currency"]),
                          getDecimals(TOTALS),
                        )}
                      </p>
                      <p className="subTitE" style={{ fontWeight: "700" }}>
                        Total Cert. Previa
                      </p>
                    </div>
                  </div>
                  <div id="PresCoste" style={{ marginRight: "40px" }}>
                    <div style={{ marginRight: "40px" }}>
                      <p className="totalE">
                        {currencyFormatDE(
                          budgetTree.totalCurrentCertificateProject || 0,
                          getCurrency(user["custom:currency"]),
                          getDecimals(TOTALS),
                        )}
                      </p>
                      <p className="subTitE">Total Cert. Actual</p>
                    </div>
                  </div>
                </div>
              ) : (
                <div id="desglosePresShow" className="budgetFooterCostsRow">
                  <div className="budgetFooterCell">
                    <div style={{ marginRight: "15px" }}>
                      <div
                        className="cuadMargins"
                        onClick={() => {
                          freeTrialExpired
                            ? openFreeTrialExpire()
                            : marginModal.setMarginModal(true, projectId)
                        }}
                      >
                        <HelveticaBold
                          style={{
                            color: "white",
                            cursor: "pointer",
                            fontWeight: "700",
                            fontSize: "30px",
                            marginTop: "-2px",
                            position: "relative",
                          }}
                        >
                          {totalPercent}
                        </HelveticaBold>
                        <HelveticaBold
                          style={{
                            color: "white",
                            fontWeight: "700",
                            fontSize: "20px",
                            paddingTop: "8px",
                            marginLeft: "2px",
                          }}
                        >
                          %
                        </HelveticaBold>
                      </div>
                      <p className="totalE">{dif}</p>
                      <p className="subTitE">
                        {i18n.t("budgetStructure.footer.margin")}
                      </p>
                    </div>
                  </div>
                  <div className="budgetFooterCell">
                    <div style={{ marginRight: "15px" }}>
                      <p className="totalE">
                        {currencyFormatDE(
                          budgetTree.price,
                          getCurrency(user["custom:currency"]),
                          getDecimals(TOTALS),
                        )}
                      </p>
                      <p className="subTitE">
                        {i18n.t("budgetStructure.footer.priceObjectiveTotal")}
                      </p>
                    </div>
                  </div>
                  {(isTenderClosed ||
                    budgetTree.price !== budgetTree.priceReduced) && (
                    <div className="budgetFooterCell">
                      <div style={{ marginRight: "15px" }}>
                        <p className="totalE">
                          {currencyFormatDE(
                            footerReducedPrice,
                            getCurrency(user["custom:currency"]),
                            getDecimals(TOTALS),
                          )}
                        </p>
                        <p className="subTitE">
                          {i18n.t("budgetStructure.footer.priceReducedTotal")}
                          {isTenderClosed && <> (ofertado)</>}
                        </p>
                      </div>
                    </div>
                  )}
                  {/* Hidden for now */}
                  {preferencias.costReal && false && (
                    // Where to force budgetTree.costReal to be calculated on load?
                    <div id="PresCoste">
                      <div style={{ marginRight: "15px" }}>
                        <p className="totalE">
                          {currencyFormatDE(
                            soyFinal ? budgetTree.costReal : 0,
                            getCurrency(user["custom:currency"]),
                            getDecimals(TOTALS),
                          )}
                        </p>
                        <p className="subTitE">
                          {i18n.t("budgetStructure.footer.costRealTotal")}
                        </p>
                      </div>
                    </div>
                  )}
                  <div className="budgetFooterCell budgetFooterCell--last">
                    <div style={{ marginRight: "15px" }}>
                      <p className="totalE">
                        {formattedFooterClientPriceTotal}
                      </p>
                      <p className="subTitE">
                        {i18n.t("budgetStructure.footer.clientPrice")}
                        {isTenderClosed && <> (ofertado)</>}
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <Fragment>
              <div id="centerPaco">
                <img
                  src={BudgetingVacio}
                  style={{ width: "343px", height: "321px", marginTop: "5%" }}
                ></img>
              </div>
            </Fragment>
          )
        ) : (
          <div
            style={{
              overflowX: "hidden",
              marginLeft: "30px",
              marginRight: "12px",
            }}
          >
            {chaptersForList.length === 0 && budgetSearchTrimmed ? (
              <HelveticaBold
                style={{
                  color: "#414141",
                  marginTop: "16px",
                  marginBottom: "16px",
                  fontSize: "15px",
                }}
              >
                {i18n.t("No hay resultados para la búsqueda")}
              </HelveticaBold>
            ) : (
              chaptersForList.map((subcapitulo, index) => (
                <NewCapitulo
                  imTemplate={imTemplate}
                  key={subcapitulo.chapterId ?? index}
                  indice={index}
                  capitulo={subcapitulo}
                  desplazamiento={24}
                  numeroClases={numeroClases}
                  numeroIndex={index + 1}
                  lengthSubCap={budgetTree.subcapitulos.length}
                  soyFinal={soyFinal}
                  projectInfo={projectInfo}
                  setModificado={setModificado}
                  modificado={modificado}
                  setClose={setClose}
                  modificarMargen={modificarMargen}
                  setModificarMargen={setModificarMargen}
                  ocultoFinal={ocultoFinal}
                  setOcultoFinal={setOcultoFinal}
                  isChecked={isChecked}
                  setIsChecked={setIsChecked}
                  certificaciones={certificaciones}
                  isChecked2={isChecked2}
                  setIsChecked2={setIsChecked2}
                  priceWidth={3}
                  version={version}
                  budgetSearchQuery={budgetSearchQuery}
                  openModalCreatePartida={newModalPart.open}
                  setOpenModalCreatePartida={isOpen =>
                    newModalPart.setProperty("open", isOpen)
                  }
                />
              ))
            )}
            {projectInfo.status === "CLOSED" ||
            version ||
            certificaciones ? null : (
              <div
                className="NombreAlign"
                onClick={freeTrialExpired ? openFreeTrialExpire : addCapitulo}
              >
                <button
                  className="nuevoBotonCrear4"
                  style={{
                    marginTop: "10px",
                    marginBottom: "30px",
                    width: "fit-content",
                  }}
                  data-amplify-analytics-on="click"
                  data-amplify-analytics-name="ChapterCreated"
                  data-amplify-analytics-attrs=""
                  data-testid="budget-add-chapter-button"
                >
                  + {i18n.t("Nuevo capítulo")}
                </button>
              </div>
            )}
          </div>
        )}
      </LayoutBudget>

      {marginModal.open && <MarginsModal />}

      {openSendBudgetModal && (
        <SendModal
          open={openSendBudgetModal}
          setOpen={setOpenSendBudgetModal}
          contactos={Contacts}
          soyFinal={soyFinal}
        />
      )}
      {openDownloadBudgetModal && (
        <DownloadBudgetModal
          open={openDownloadBudgetModal}
          setOpen={setOpenDownloadBudgetModal}
          name={projectInfo.name}
          soyFinal={soyFinal}
        />
      )}
      {(chaptersChecked.length > 0 || partsChecked.length > 0) && (
        <TopQuickBudgetMenu soyFinal={soyFinal} />
      )}
    </MarginsDiscountsProvider>
  )
}

BudgetStructure.propTypes = {
  soyFinal: PropTypes.bool,
  version: PropTypes.object,
  index: PropTypes.number,
  imTemplate: PropTypes.bool,
  certificaciones: PropTypes.bool,
}

export default BudgetStructure
